module.exports = __webpack_public_path__ + "img/bg_reserve.77cc4080.png";